import { useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { UserRegistrationContext } from "../../providers/UserRegistrationProvider";
import { colors } from "../../theme/palette";

function RegistrationModal() {
  const { open, lineProfile, register, dismiss } = useContext(
    UserRegistrationContext
  );

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{ sx: { borderRadius: "18px", backgroundColor: colors.card } }}
    >
      <DialogTitle>アカウント登録</DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          py={1}
        >
          {lineProfile?.pictureUrl && (
            <Avatar
              src={lineProfile.pictureUrl}
              alt={lineProfile.displayName}
              sx={{ width: 72, height: 72 }}
            />
          )}
          <Typography variant="body1">
            <strong>{lineProfile?.displayName}</strong> としてアカウントを登録しますか？
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            登録するとアプリの機能を利用できます。
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 1, pb: 2 }}>
        <Button variant="outlined" onClick={dismiss}>
          登録しない
        </Button>
        <Button variant="contained" onClick={register}>
          登録する
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RegistrationModal;
